import React from 'react';
import classes from './Order.css';
import { withRouter } from 'react-router-dom';
import Button from '../UI/Button/Button'



const order = (props) => {

  return <div className={classes.Wrapper}>
    <div className={classes.OrderContainer}>
      <div className={classes.RowDivider}>
        <div className={classes.Content}>
          <h3 className={classes.Title}>Order #{props.orderID}</h3>
          {/* <Burger ingredients={props.ingredients} /> */}
          <div className={classes.Details}>
            <div className={classes.Ingredients}>
              <p ><b>Ingredients:&nbsp;</b></p>
              {props.ingredients.lettuce ? <p className={classes.Ingredient}>Lettuce ({props.ingredients.lettuce})&nbsp;</p> : null}
              {props.ingredients.bacon ? <p className={classes.Ingredient}>Bacon ({props.ingredients.bacon})&nbsp;</p> : null}
              {props.ingredients.meat ? <p className={classes.Ingredient}>Meat ({props.ingredients.meat})&nbsp;</p> : null}
              {props.ingredients.cheese ? <p className={classes.Ingredient}>Cheese ({props.ingredients.cheese})&nbsp;</p> : null}
            </div>
            <div><p><b>Price:</b> ${props.price.toFixed(2)}</p></div>
          </div>
        </div>
        <Button clicked={() => { props.history.push(`/orders/${props.orderID}`) }} style={{ height: '45px', boxShadow: '1px 1px 3px #999999' }} btnType="Orange">See Details</Button>
      </div>
    </div>


  </div>


}

export default withRouter(order);




// WEBPACK FOOTER //
// ./src/components/Order/Order.jsx